import { filter } from 'lodash';

const formatTeamData = (data, mediaPath, id) => {
  let teams = [];
  const memberData = data.teamMembers;
  let teamPageData = filter(
    data && data.teams,
    ({ vertical_id }) => vertical_id === id
  );
  teamPageData.length > 0 &&
    teamPageData.map((team, idx) => {
      const result = {
        web: mediaPath.web,
        mobile: mediaPath.mobile,
        thumbnail: mediaPath.thumbnail,
        title: team.title,
        tag_word: team.tag_word,
        description: team.description,
        mobile_description: team.mobile_description,
        vertical_id: team.vertical_id,
        testimonial_clients: memberData,
        join_team_link: team.join_team_link,
      };
      teams.push(result);
    });

  return teams;
};

export const TeamMapper = {
  formatTeamData,
};
